import { ExpandedMediaRecordFromAPI, MediaRecordFromAPI } from '../types';
import apiRequest from './apiRequest';

export async function getAllMedia() {
  const { data, error } = await apiRequest<MediaRecordFromAPI[]>(
    'mogen-orchestration',
    `/media`,
    {
      method: 'GET',
    },
  );

  return { data, error };
}

export async function getAllMediaExpanded() {
  const { data, error } = await apiRequest<ExpandedMediaRecordFromAPI[]>(
    'mogen-orchestration',
    `/media`,
    {
      method: 'GET',
    },
  );

  return { data, error };
}
